import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "gfu-general-message-info gfu-project-navigation-archive",
  "data-qa": "project-navigation-archive"
}
const _hoisted_2 = { class: "gfu-general-message-info__icon" }
const _hoisted_3 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, [
      _createVNode(_component_base_icon, {
        name: "brand-outline",
        "icon-namespace": "ga",
        class: "_mr-1"
      })
    ]),
    _createElementVNode("div", null, [
      _createTextVNode(_toDisplayString($options.message) + " ", 1 /* TEXT */),
      _createElementVNode("a", {
        href: $props.projectUrl,
        class: "_tdu",
        "data-qa": "current-project-view"
      }, _toDisplayString($options.linkMessage), 9 /* TEXT, PROPS */, _hoisted_3),
      _cache[0] || (_cache[0] = _createTextVNode(". ", -1 /* CACHED */))
    ])
  ]))
}